import { jsx } from "react/jsx-runtime";
import assert from "assert";
import { forwardRef, useContext } from "react";
import { Box } from "../Box/Box.mjs";
import { buildDataAttributes } from "../private/buildDataAttributes.mjs";
import { TableContext, TableHeaderContext } from "./TableContext.mjs";
import { tableSection, tableHeader } from "./Table.css.mjs";
const TableHeader = forwardRef(({ children, data, ...restProps }, ref) => {
  const tableContext = useContext(TableContext);
  assert(tableContext, "TableHeader must be used within a Table component");
  return /* @__PURE__ */ jsx(TableHeaderContext.Provider, { value: true, children: /* @__PURE__ */ jsx(
    Box,
    {
      component: "thead",
      className: [tableSection, tableHeader],
      ref,
      ...buildDataAttributes({ data, validateRestProps: restProps }),
      children
    }
  ) });
});
export {
  TableHeader
};
